import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Privacy } from '../../pages/privacy';
import { PrivacyMarketing } from '../../pages/privacy/marketing';
import { PrivacyThirdParty } from '../../pages/privacy/thirdParty';

export const Terms = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const termType = location.state?.type || 'setting_terms';
  const content = termType === 'setting_terms' ? <Privacy /> : termType === 'privacy_title' ? <Privacy /> : termType === 'privacy_third_party_title' ? <PrivacyThirdParty /> : termType === 'privacy_marketing_title' ? <PrivacyMarketing /> : null;

  return (
    <Box sx={{
      margin: 0,
      mt: '0px',
      pt: 0,
      flexDirection: 'column',
      background: '#FFF'
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', height: '54px', px: 2, borderBottom: '1px solid rgba(0,0,0,0.10)', background: '#F5F3F6' }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mr: 1 }}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '15px', color: '#211F20',  }}>
          {t(termType)}
        </Typography>
      </Box>
      <Box sx={{ p: 3 }}>
        {content}
      </Box>
    </Box>
  );
};
